import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DynamicFormService } from '../../../../routes/dev-tools/dynamic-form/dynamic-form.service';
import { ScoringValueService } from '../../../../routes/jy-srm/marking-scheme/marking-scheme/scoring-value.service';
import { CommonsService } from '@core/service/commons.service';
import { ScoringComponentComponent } from '@shared/components/score/scoring-component/scoring-component.component';
import { PersonService } from '../../../../routes/jy-org/person/service/person.service';

@Component({
  selector: 'app-scoring',
  templateUrl: './scoring.component.html',
  styles: []
})
export class ScoringComponent implements OnInit {
  @Input()scoringScheme;
  @Input()readOnly;
  @Output() private childOuter = new EventEmitter();
  @ViewChild('scoringComponent')
  scoringComponent:ScoringComponentComponent;
  constructor(private dynamicFormService:DynamicFormService,private scoringValueService:ScoringValueService,private commonsService:CommonsService,public personService:PersonService) { }
  getCurrrentScoringPerson(scoringSchemeDetail:any,currentPerson:any){
    if(scoringSchemeDetail.scoringPersonType=='PERSON'){
      //人员
      let  scoringPeople=scoringSchemeDetail.scoringPeople.filter(scoringPerson=>scoringPerson.person.id==currentPerson.id);
      if(scoringPeople && scoringPeople.length){
        return scoringPeople[0];
      }
    }else{
      //专家
      let  scoringPeople=scoringSchemeDetail.scoringPeople.filter(scoringPerson=>scoringPerson.expert.personDto.id==currentPerson.id);
      if(scoringPeople && scoringPeople.length){
        return scoringPeople[0];
      }
    }
    return null;
  }
  //评分方案列表表格
  allChecked = false;
  indeterminate = false;
  displayData = [];
  currentPageDataChange($event): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }
  //打开的评分方案index
  public planIndex:number;

  //组长评分抽屉
  public leaderScoreVisibile:boolean = false;
  //评分数据
  public scoreData:any = [];
  public personIsScore:boolean = false;
  public scorePeopleObj:any = {};//已评分人员
  leaderScore(scoringPlan,index,isScore?){
    if(isScore){
      this.personIsScore = true;
    }else{
      this.personIsScore = false;
    }
    this.leaderSelectIndex = 0;
    this.planObj = scoringPlan;
    this.expandFieldGroup();
    this.planIndex = index;
    this.scoringValueService.getCurrentByScoringSchemeDetailId(this.planObj.id).subscribe((data) => {
      this.scoreData = data;
      if(this.scoreData.data[this.planObj.dynamicForm.dynamicTables[0].tableName]){
        this.scoreData.data[this.planObj.dynamicForm.dynamicTables[0].tableName].forEach((people)=>{
          this.scorePeopleObj[people.person] = people;
        });
      }
    });
    this.leaderScoreVisibile = true;
  }
  closeLeaderScoreDrawer(){
    this.leaderScoreVisibile = false;
  }
  scoringFinish(scoreFields){
    this.leaderScoreVisibile = false;
    if(this.scoreData.data && this.scoreData.data.isLeader){
      this.planObj.status = "FINISH";
      this.planObj.totalScore = scoreFields.total_score;
      for(let i = 0;i < this.scoringScheme.scoringSchemeDetails.length;i++){
        if(this.scoringScheme.scoringSchemeDetails[i].status != 'FINISH'){
          return;
        }
      }
      this.childOuter.emit();//组长评分完成，外层升降机制触发
    }
    this.getCurrrentScoringPerson(this.planObj, this.personService.currentPerson).status = 'FINISH';
  }

  public leaderSelectIndex:number = 0;
  goScoring(){
    this.leaderSelectIndex = 1;
  }
  //组长设置组员重新评分
  againScoring(people){
    this.scoringValueService.reScoring(people.id).subscribe((data)=>{
      if(data.status){
        this.commonsService.showSuccessMessage('shared.score.scoring.succeed');
        people.status = "ONGOING";
      }
    });
  }
  //禁止组员评分
  disabledScoring(people){
    this.scoringValueService.disableScoring(people.id).subscribe((data)=>{
      if(data.status){
        people.status = "DISABLED";
        this.commonsService.showSuccessMessage('shared.score.scoring.succeed');
      }
    });
  }

  //提交分数
  submitScoring(){
    if(this.scoreData.data && this.scoreData.data.isLeader){
      for(let i=0;i<this.planObj.scoringPeople.length;i++){
        if(!this.planObj.scoringPeople[i].isLeader && this.planObj.scoringPeople[i].status == 'ONGOING'){
          this.commonsService.showWarningMessage('shared.score.scoring.notScored');
          return;
        }
      }
    }
    this.scoringComponent.submitScoring();
  }

  //详情状态抽屉
  public detailIsVisibile:boolean = false;
  closeDetailIsVisibile(){
    this.detailIsVisibile = false;
  }
  public viewSelectIndex:any = 0;
  viewDetail(scoringPlans){
    this.viewSelectIndex = 0;
    this.planObj = scoringPlans;
    this.expandFieldGroup();
    this.scoringValueService.getByScoringSchemeDetailId(this.planObj.id).subscribe((data) => {
      this.scoreData = data;
      if(this.scoreData.data[this.planObj.dynamicForm.dynamicTables[0].tableName]){
        this.scoreData.data[this.planObj.dynamicForm.dynamicTables[0].tableName].forEach((people)=>{
          this.scorePeopleObj[people.person] = people;
        });
      }
      for(let i=0;i<this.planObj.scoringPeople.length;i++){
        if(this.planObj.scoringPeople[i].isLeader){
          if(this.planObj.scoringPersonType == 'PERSON'){
            this.scoreData.data['personId']  = this.planObj.scoringPeople[i].person.id;
          }else if(this.planObj.scoringPersonType == 'EXPERT'){
            this.scoreData.data['personId']  = this.planObj.scoringPeople[i].expert.personDto.id;
          }
          break;
        }
      }
    });
    this.detailIsVisibile = true;
  }
  //字段分组默认展开
  expandFieldGroup(){
    this.planObj.dynamicForm.dynamicTables[0].dynamicFieldGroups.forEach((data)=>{
      data.expand = true;
    });
  }

  //数据
  public planObj:any = {};
  ngOnInit() {

  }

}
